<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.42505 16.5984L12.8584 11.1651C13.5 10.5234 13.5 9.47344 12.8584 8.83177L7.42505 3.39844" stroke="currentColor" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
